import { render, staticRenderFns } from "./ShowScreenshots.vue?vue&type=template&id=3420aea6&"
import script from "./ShowScreenshots.vue?vue&type=script&lang=js&"
export * from "./ShowScreenshots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports